// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_bUi","cls2":"FallbackBulkDownloadUpsellModalControl-cls2___V FallbackBulkDownloadUpsellModalControl-cls1_bUi"};